// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"7f68293e","462":"64709774","567":"30d46202","713":"e8563e26"}[chunkId] + ".chunk.js";
};